import React from 'react';
import DamageCheckMap from './DamageCheckMap';

// 업체가 직접 검차 정보 입력 (eval_results 미연동 차량용)
// value: { paintData: {...}, damageData: {...}, score: number }
// onChange: (newValue) => void

var PAINT_PARTS=[
  {key:'hood',label:'본넷'},
  {key:'roof',label:'루프'},
  {key:'trunk',label:'트렁크'},
  {key:'fenderL',label:'좌앞펜더'},
  {key:'fenderR',label:'우앞펜더'},
  {key:'doorFL',label:'좌앞문'},
  {key:'doorFR',label:'우앞문'},
  {key:'doorRL',label:'좌뒷문'},
  {key:'doorRR',label:'우뒷문'},
  {key:'quarterL',label:'좌쿼터'},
  {key:'quarterR',label:'우쿼터'}
];

function getColor(v){
  if(!v)return {bg:'#f8fafc',border:'#e2e8f0',fg:'#94a3b8',label:''};
  var n=parseInt(v)||0;
  if(n<150)return {bg:'#E1F5EE',border:'#1D9E75',fg:'#1D9E75',label:'정상'};
  if(n<250)return {bg:'#FAEEDA',border:'#EF9F27',fg:'#EF9F27',label:'의심'};
  return {bg:'#FCEBEB',border:'#E24B4A',fg:'#E24B4A',label:'판금'};
}

function AuctionSelfInspection(props){
  var value=props.value||{};
  var onChange=props.onChange;
  var paintData=value.paintData||{};
  var damageData=value.damageData||{};
  var score=(value.score===0||value.score)?String(value.score):'';

  var emit=function(patch){
    if(!onChange)return;
    onChange(Object.assign({paintData:paintData,damageData:damageData,score:value.score},patch));
  };

  var updatePaint=function(key,numStr){
    var next=Object.assign({},paintData);
    if(numStr===''||numStr===null){delete next[key]}
    else{next[key]=parseInt(numStr)||0}
    emit({paintData:next});
  };

  var updateDamage=function(newDmg){
    emit({damageData:newDmg||{}});
  };

  var updateScore=function(s){
    var raw=String(s||'').replace(/[^0-9]/g,'');
    if(raw===''){emit({score:undefined});return}
    var n=parseInt(raw)||0;
    if(n<0)n=0;if(n>100)n=100;
    emit({score:n});
  };

  return (
    <div style={{display:'flex',flexDirection:'column',gap:12}}>
      {/* 도막 측정 */}
      <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,border:'1px solid #e2e8f0'}}>
        <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:8,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:4}}>
          <span>🎨 도막 측정 (μm)</span>
          <span style={{fontSize:9,color:'#94a3b8',fontWeight:500}}>&lt;150 정상 · 150~249 의심 · ≥250 판금</span>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6}}>
          {PAINT_PARTS.map(function(p){
            var v=paintData[p.key];
            var shown=(v===0||v)?String(v):'';
            var c=getColor(v);
            return (
              <div key={p.key} style={{padding:'6px 8px',background:c.bg,border:'1px solid '+c.border,borderRadius:6}}>
                <div style={{fontSize:9,color:'#64748b',fontWeight:600,marginBottom:2}}>{p.label}</div>
                <div style={{display:'flex',alignItems:'baseline',gap:3}}>
                  <input type="text" inputMode="numeric"
                    value={shown}
                    onChange={function(e){
                      var raw=e.target.value.replace(/[^0-9]/g,'');
                      updatePaint(p.key,raw);
                    }}
                    placeholder="-"
                    style={{flex:1,minWidth:0,padding:0,background:'transparent',border:'none',fontSize:15,fontWeight:800,color:c.fg,outline:'none',textAlign:'left'}}/>
                  {c.label&&<span style={{fontSize:8,color:c.fg,fontWeight:700,whiteSpace:'nowrap'}}>{c.label}</span>}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 사고 부위 4면도 (edit 모드) */}
      <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,border:'1px solid #e2e8f0'}}>
        <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:8}}>🔧 사고 부위 (탭해서 마킹)</div>
        <DamageCheckMap value={damageData} onChange={updateDamage} readOnly={false}/>
      </div>

      {/* 종합 점수 */}
      <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,border:'1px solid #e2e8f0',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        <div style={{fontSize:11,fontWeight:700,color:'#475569'}}>⭐ 종합 점수 (0~100)</div>
        <input type="text" inputMode="numeric"
          value={score}
          onChange={function(e){updateScore(e.target.value)}}
          placeholder="95"
          style={{width:80,padding:'6px 10px',border:'1px solid #cbd5e1',borderRadius:6,fontSize:14,fontWeight:700,textAlign:'center',outline:'none'}}/>
        <div style={{fontSize:10,color:'#94a3b8',flex:1,textAlign:'right'}}>자가 판단 기준 (선택)</div>
      </div>
    </div>
  );
}

export default AuctionSelfInspection;
